// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"IframeContentOverlay_overlayContainer__o2CzL","overlay":"IframeContentOverlay_overlay__P3KMN"};